/* Блокировка скролла страницы под модалкой.

   На десктопе ничего не делаем: MUI ModalManager сам ставит body overflow: hidden
   и компенсирует пропавший скроллбар через padding-right. Если поверх этого выставить
   свой overflow-y, компенсация и скроллбар разъезжаются, и нижняя модалка прыгает
   на половину ширины скроллбара при открытии вложенной (KNM-136).

   На мобильном MUI недостаточно: iOS продолжает тянуть страницу под модалкой,
   поэтому дополнительно фиксируем body.

   Счётчик нужен из-за вложенных модалок: блокировку снимает только последняя закрытая. */

let depth = 0
let isLocked = false

const applyLock = (): void => {
  document.body.style.position = 'fixed'
  document.body.style.height = `calc(${window.innerHeight}px - 1px)`
  document.body.style.touchAction = 'none'
  document.body.ontouchmove = (e) => {
    e.preventDefault()
    return false
  }
  document.body.onscroll = (e) => {
    e.preventDefault()
    return false
  }
}

const releaseLock = (): void => {
  document.body.style.height = 'initial'
  document.body.style.touchAction = 'auto'
  document.body.style.position = 'initial'
  document.body.ontouchmove = null
  document.body.onscroll = null
}

export const lockBodyScroll = (isMobile: boolean): void => {
  depth += 1

  if (depth === 1 && isMobile) {
    isLocked = true
    applyLock()
  }
}

export const unlockBodyScroll = (): void => {
  if (depth === 0) {
    return
  }

  depth -= 1

  if (depth === 0 && isLocked) {
    isLocked = false
    releaseLock()
  }
}
